export default "__VITE_ASSET__BpZEHveq__"